import React from 'react'
import { StyleSheet, View } from 'react-native'

import { Box } from 'widgets/Box'
import { Pressable } from 'widgets/Pressable'
import { Separator } from 'widgets/Separator'
import { Text } from 'widgets/Text'

import { useTheme } from 'contexts/ThemeContext'

type OptionItemProps = {
  option?: string
  onSelect: () => void
  isCancelItem: boolean
  isCompact?: boolean
  isInModal?: boolean
  isLastOption?: boolean
}

export const OptionItem = ({
  option,
  onSelect,
  isCancelItem,
  isCompact = false,
  isInModal = true,
  isLastOption = false,
}: OptionItemProps) => {
  const theme = useTheme()
  const computedStyles = StyleSheet.create({
    fullWidthSeparator: {
      borderWidth: 0.5,
      borderStyle: 'solid',
      borderColor: theme.colors.grey,
    },
  })

  return (
    <Pressable onPress={onSelect}>
      <Box height={!isCompact ? 44 : 33}>
        <Box
          flex={1}
          flexDirection='row'
          justifyContent='center'
          align='center'
          margin={{ horizontal: 'xl' }}
        >
          <Text
            numberOfLines={1}
            align='center'
            fontSize='sm'
            color={isCancelItem ? 'error' : 'greyDarkest'}
          >
            {isCancelItem ? 'Cancel' : option}
          </Text>
        </Box>
        {!isCancelItem && isInModal && <Separator />}
        {!isCancelItem && !isInModal && !isLastOption && (
          <View style={computedStyles.fullWidthSeparator} />
        )}
      </Box>
    </Pressable>
  )
}
